import { defineModule } from '@portal/kernel';

export const manifest = defineModule({
  key: 'core-audit',
  version: '0.1.0',
  kind: 'core',
  coreVersion: '^0.1.0',
  name: { vi: 'Nhật ký hệ thống', en: 'Audit log' },
  description: {
    vi: 'Ghi lại ai làm gì, trên đối tượng nào, khi nào và từ đâu. Chỉ ghi thêm, không sửa/xoá.',
    en: 'Records who did what, to which object, when and from where. Append-only.',
  },
  dependsOn: ['core-system'],
  database: { schema: 'core_audit' },
  permissions: [
    { key: 'core-audit.log.view', name: { vi: 'Xem nhật ký hệ thống', en: 'View audit log' } },
  ],
  navigation: [
    {
      id: 'admin.audit',
      parent: 'admin',
      label: { vi: 'Nhật ký hoạt động', en: 'Activity log' },
      icon: 'history',
      path: '/admin/audit',
      permission: 'core-audit.log.view',
      order: 20,
    },
  ],
});
